import {useNavigate, useParams} from "react-router-dom";
import {Box, Grid, Link, Typography} from "@mui/material";
import { useTranslation } from "react-i18next";
import { artists } from "../assets/content/artists/artists";
import { links } from "../assets/content/artist/links.js";
import {useEffect, useState} from "react";
import {loadMarkdown} from "../utils/loadMarkdown";
import MuiMarkdown from "../components/MuiMarkdown";
import YouTubeVideo from "../components/YoutubeVideo";
import ImageCarousel from "../components/ImageCarousel";

export default function ArtistDetail({ lang }) {
    const { name } = useParams();
    const [artist, setArtist] = useState(null);
    const { t } = useTranslation();
    const [bio, setBio] = useState("");
    const navigate = useNavigate();

    const removeProtocol = (url) => {
        return url.replace(new RegExp("http(s)?://"), "");
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const artist = artists.find(a => a.name === name);
        if (artist === undefined) {
            navigate("/not-found?artist=" + name);
        }
        loadMarkdown("artist", lang, artist.name+"-bio").then(setBio);
        setArtist(artist);
    }, [navigate, name, lang, bio]);

    return (artist === null) ? <></> :
        <Box width="100%" height="100%" display="flex" flexDirection="column" justifyContent="space-between" alignItems="center" flexGrow={{ xs: 0, md: 1 }}
             minHeight={{ xs: 'auto', md: 0 }}>
            <Box width="100%" mb={2}>
                {/*ARTIST NAME*/}
                <Typography variant="h4">{artist.displayName.split("–")[0]}</Typography>
                {(artist.displayName.split("–").length > 1) && <Typography variant="h5">{artist.displayName.split("–")[1]}</Typography>}
                <Typography variant="h6" mb={4}>{t(`artists.${artist.titleKey}`)}</Typography>

                {/*ARTIST BIO*/}
                <Grid container columnSpacing={2} rowSpacing={2} sx={{
                    justifyContent: {
                        xs: "center",
                        md: "space-between",
                    },
                    alignItems: "top"
                }} flexGrow={{ xs: 0, md: 1 }}
                      minHeight={{ xs: 'auto', md: 0 }}>
                    <Grid textAlign="left" maxWidth={{ xs: "100%", md: "50%", lg: "60%", xl: window.innerWidth >= 2560 ? "75%" : "60%"}} order={{ xs: 2, md: 1 }}>
                        {bio !== null && bio !== "" && <MuiMarkdown>{bio}</MuiMarkdown>}
                        {links[name].site && <Link href={links[name].site}>{removeProtocol(links[name].site)}</Link>}
                    </Grid>
                    <Grid order={{ xs: 1, md: 2 }}>
                        <ImageCarousel images={links[name].images ? links[name].images : []} slidesToShow={{xs: 1}} showArrows={links[name].images.length > 1} maxWidth={{xs: "100%", sm: "430px", xl: "520px"}}
                        imageHeight={{xs: 260, xl: 350}}/>
                    </Grid>
                </Grid>
            </Box>

            <Box width="100%">
                <Grid width="100%" container columnSpacing={2} rowSpacing={2}>
                    {links[name].videos && links[name].videos.map((video, index) => (
                        <Grid size={{ xs: 12, sm: 6, md: 4}} key={index}>
                            <YouTubeVideo title={video.name} url={video.link} videoHeight={{xs: 250, xl: window.innerWidth >= 2560 ? 400 : 250}}/>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>;
}